<template>
    <layout class="app-download-page">
        <div class="bg_app">
            <!-- App Download Wrapper with shared background -->
            <div class="app-download-wrapper">
                <!-- Start Banner Area -->
                <div class="slider-one rn-section-gapTop app-banner">
                    <div class="container">
                        <div class="row row-reverce-sm align-items-center">
                            <div class="col-lg-6 col-md-6 col-sm-12 mt_sm--50">
                                <div class="app-banner-content">
                                    <h2 class="app-brand">Matrix Power</h2>
                                    <h3 class="app-title">{{ $t('appDownload.butler') }}</h3>
                                    <p class="app-desc">{{ $t('appDownload.title') }}</p>

                                    <div class="app-buttons">
                                        <button @click="showDownloadModal = true" class="btn android-btn">
                                            <img style="width:25px;height: auto;" src="@/assets/images/icons/icon_xiazai_anzhuo@3x.png" alt="">
                                            <span>Android</span>
                                        </button>
                                        <a href="https://apph5.matrixpower.club/">
                                            <button class="btn h5-btn">
                                                <img src="@/assets/images/bg/图标 35.png" alt="" class="h5-icon">
                                                <span>H5</span>
                                            </button>
                                        </a>
                                    </div>

                                    <div class="app-users">
                                        <div class="user-avatars">
                                            <img src="@/assets/images/bg/组件 93.png" alt="用户头像" class="avatar-stack">
                                        </div>
                                        <div class="user-stats">
                                            <span class="stats-number">{{ $t('appd.servedUsers') }}</span>
                                            <span class="stats-text">{{ $t('appd.usersLabel') }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-5 col-md-6 col-sm-12 offset-lg-1">
                                <div class="app-phone-showcase">
                                    <img src="@/assets/images/bg/iPhone.png" alt="App界面" class="app-phone-img">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Matrix Power App Features Section -->
                <div class="app-features-section">
                    <div class="container">
                        <div class="row align-items-center">
                            <!-- 左侧手机展示 -->
                            <div class="col-lg-5 col-md-6 col-sm-12">
                                <div class="feature-phone-showcase">
                                    <!-- 桌面端手机图 -->
                                    <transition name="phone-fade" mode="out-in">
                                        <img :key="activeFeature"
                                            :src="require(`@/assets/images/bg/${features[activeFeature].phoneImage}`)"
                                            alt="App界面" class="feature-phone-img">
                                    </transition>
                                    <!-- H5 手机图（阴影版） -->
                                    <transition name="phone-fade" mode="out-in">
                                        <img :key="activeFeature"
                                            :src="require(`@/assets/images/bg/${features[activeFeature].h5Image}`)"
                                            alt="App界面" class="feature-phone-img-h5">
                                    </transition>
                                </div>
                            </div>
                            <!-- 右侧内容 -->
                            <div class="col-lg-7 col-md-6 col-sm-12">
                                <div class="feature-content">
                                    <h2 class="feature-main-title">Matrix Power App</h2>
                                    <p class="feature-desc">{{ $t('appd.trustDesc') }}<br>{{ $t('appDownload.title') }}
                                    </p>

                                    <!-- 功能模块切换面板：点击切换内容 -->
                                    <div class="feature-switch-panel" @click="nextFeature">
                                        <div class="feature-header">
                                            <span class="feature-icon-box">
                                                <img :src="features[activeFeature].icon" alt="" class="feature-icon-img">
                                            </span>
                                            <h4 class="feature-title">{{ features[activeFeature].title }}</h4>
                                        </div>
                                        <p class="feature-text">{{ features[activeFeature].desc }}</p>
                                        <svg class="feature-chevron" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M3 6l5 5 5-5" stroke="rgba(255,255,255,0.6)" stroke-width="1.5"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>

                                    <!-- 统计数据 -->
                                    <div class="feature-stats">
                                        <div class="stat-item">
                                            <span class="stat-number">180+</span>
                                            <span class="stat-label">{{ $t('appd.statRegion') }}</span>
                                        </div>
                                        <div class="stat-item">
                                            <span class="stat-number">4.9</span>
                                            <span class="stat-label">{{ $t('appd.statRating') }}</span>
                                        </div>
                                        <div class="stat-item">
                                            <span class="stat-number">98.9%</span>
                                            <span class="stat-label">{{ $t('appd.statPositive') }}</span>
                                        </div>
                                        <div class="stat-item">
                                            <span class="stat-number">2.4k</span>
                                            <span class="stat-label">{{ $t('appd.statDownloads') }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 资金安全保障 Section -->
            <div class="security-section">
                <div class="container">
                    <h2 class="security-title">{{ $t('quantPage.coop.c1Title') }}</h2>
                    <p class="security-subtitle">{{ $t('appd.secSubtitle') }}</p>

                    <!-- H5 轮播：桌面端透传（display:contents），卡片仍参与网格布局 -->
                    <div class="security-carousel">
                        <div class="security-viewport">
                            <div class="security-track"
                                :style="{ transform: `translateX(-${securityIndex * 100}%)` }">
                                <!-- 客户资产保障 -->
                                <div class="security-card security-card-1">
                                    <img src="@/assets/images/bg/组 66.png" alt="" class="security-icon-img">
                                    <h3 class="security-card-title">{{ $t('appd.assetTitle') }}</h3>
                                    <ul class="security-list">
                                        <li>{{ $t('appd.assetL1') }}</li>
                                        <li>{{ $t('appd.assetL2') }}</li>
                                        <li>{{ $t('appd.assetL3') }}</li>
                                    </ul>
                                    <div class="security-tags">
                                        <span class="tag-green">{{ $t('appd.tagPrincipal') }}</span>
                                        <span class="tag-blue">{{ $t('appd.tagSelfOpen') }}</span>
                                    </div>
                                </div>

                                <!-- 双重风控拦截 -->
                                <div class="security-card security-card-2">
                                    <img src="@/assets/images/bg/组 80.png" alt="" class="security-icon-img">
                                    <h3 class="security-card-title">{{ $t('quantPage.coop.c1i2t') }}</h3>
                                    <ul class="security-list">
                                        <li>{{ $t('appd.dualL1') }}</li>
                                        <li>{{ $t('appd.dualL2') }}</li>
                                    </ul>
                                    <div class="security-tags">
                                        <span class="tag-green">SOC2</span>
                                        <span class="tag-yellow">{{ $t('appd.tagRiskModel') }}</span>
                                    </div>
                                </div>

                                <!-- 交易透明机制 -->
                                <div class="security-card security-card-3">
                                    <img src="@/assets/images/bg/组 94.png" alt="" class="security-icon-img">
                                    <h3 class="security-card-title">{{ $t('appd.transTitle') }}</h3>
                                    <ul class="security-list">
                                        <li>{{ $t('appd.transL1') }}</li>
                                        <li>{{ $t('appd.transL2') }}</li>
                                        <li>{{ $t('appd.transL3') }}</li>
                                    </ul>
                                    <div class="security-tags">
                                        <span class="tag-blue">{{ $t('appd.tagRealtime') }}</span>
                                        <span class="tag-green">{{ $t('appd.tagLiquid') }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- CTA Download Section -->
            <div class="cta-section">
                <div class="container">
                    <div class="cta-content">
                        <h2 class="cta-brand">Matrix Power APP</h2>
                        <h3 class="cta-title">{{ $t('appDownload.trust') }}</h3>
                        <p class="cta-desc">{{ $t('appd.ctaDesc') }}</p>

                        <div class="cta-buttons">
                            <button @click="showDownloadModal = true" class="btn cta-android-btn">
                                <img style="width:25px;height: auto;" src="@/assets/images/icons/icon_xiazai_anzhuo@3x.png" alt="">
                                <span>Android</span>
                            </button>
                            <a href="https://apph5.matrixpower.club/">
                                <button class="btn cta-h5-btn">
                                    <img src="@/assets/images/bg/图标 35.png" alt="" class="h5-icon">
                                    <span>H5</span>
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- End App Download Wrapper -->

        <!-- <div>
            <div class="container about-us">
                <h2 style=""> {{ $t('appDownload.trust') }}</h2>
                <h6 style="font-size: 14px;color: #acacac;">{{ $t('appDownload.relyOn') }}</h6>

                <div class="department-section">
                    <div class="department-card" v-for="(item, index) in departments" :key="index"
                        :class="{ 'active': item.isActive }">
                        <div class="card-icon">
                            <img :src="item.icon" :alt="item.name">
                        </div>
                        <p class="card-desc">{{ item.name }}</p>
                        <h3 class="card-title">{{ item.desc }}<br></br><div style="font-size: 14px;display: flex;justify-content: center;">{{ item.description }}</div></h3>
                        

                    </div>
                </div>

            </div>
        </div>
        <div class="app-promo-section">
            <div class="text-action-area">
                <h2 class="main-title">
                    {{ $t('appDownload.list.header_2') }}
                </h2>
                <p class="desc">
                    {{ $t('appDownload.list.p2_1') }}
                </p>
                <p class="desc">
                    {{ $t('appDownload.list.p2_2') }}
                </p>

                <div class="download-buttons">
                    <div class="download-buttons_list">
                        <div style="  white-space: nowrap;"> {{ $t('appDownload.list.footList2.Header1') }}</div>
                        <div class="download-buttons_list_title">{{ $t('appDownload.list.footList2.title1') }}</div>
                    </div>
                    <div class="line"></div>
                    <div class="download-buttons_list">
                        <div style="  white-space: nowrap;"> {{ $t('appDownload.list.footList2.Header2') }}</div>
                        <div class="download-buttons_list_title">{{ $t('appDownload.list.footList2.title2') }}</div>
                    </div>
                    <div class="line"></div>
                    <div class="download-buttons_list">
                        <div style="  white-space: nowrap;"> {{ $t('appDownload.list.footList2.Header3') }}</div>
                        <div class="download-buttons_list_title">{{ $t('appDownload.list.footList2.title3') }}</div>
                    </div>
                </div>
            </div>
            <div class="visual-area">
                <div class="phone-container">
                    <img src="@/assets/images/bg/img_app_taocan@3x.png" alt="交易APP界面" class="phone-screen">
                </div>
                <div class="decorative-elements">
                </div>

            </div>

        </div>

        <div class="app-promo-section">
            <div class="visual-area">
                <div class="phone-container">
                    <img src="@/assets/images/bg/img_app_zixun@3x.png" alt="交易APP界面" class="phone-screen">
                </div>
                <div class="decorative-elements">
                </div>

            </div>
            <div class="text-action-area">
                <h2 class="main-title">
                    {{ $t('appDownload.list.header_3') }}
                </h2>
                <p class="desc">
                    {{ $t('appDownload.list.p3_1') }}
                </p>
                <p class="desc">
                    {{ $t('appDownload.list.p3_2') }}
                </p>

                <div class="download-buttons">
                    <div class="download-buttons_list">
                        <div style="  white-space: nowrap;"> {{ $t('appDownload.list.footList3.Header1') }}</div>
                        <div class="download-buttons_list_title">{{ $t('appDownload.list.footList3.title1') }}</div>
                    </div>
                    <div class="line"></div>
                    <div class="download-buttons_list">
                        <div style="  white-space: nowrap;"> {{ $t('appDownload.list.footList3.Header2') }}</div>
                        <div class="download-buttons_list_title">{{ $t('appDownload.list.footList3.title2') }}</div>
                    </div>
                    <div class="line"></div>
                    <div class="download-buttons_list">
                        <div style="  white-space: nowrap;"> {{ $t('appDownload.list.footList3.Header3') }}</div>
                        <div class="download-buttons_list_title">{{ $t('appDownload.list.footList3.title3') }}</div>
                    </div>
                </div>
            </div>
            <DownloadConfirmModal :is-show="showDownloadModal" @close-modal="showDownloadModal = false"
                downloadUrl="http://zhibo.earningchat.com/matrixpower/app-debug.apk" />
        </div> -->




        <share-modal />

        <report-modal />
    </layout>
</template>

<script>
import Pagination from '@/components/pagination/pagination'
import BlogCard from '@/components/blog/BlogCard1'
import Breadcrumb from '@/components/breadcrumb/Breadcrumb'
import Layout from '@/components/layouts/Layout'
import SalScrollAnimationMixin from '@/mixins/SalScrollAnimationMixin'
import BlogMixin from '@/mixins/BlogMixin'
import image1 from "@/assets/images/icons/icon_xiazai_gongsi@3x.png"
import image2 from "@/assets/images/icons/icon_xiazai_yonghu@3x.png"
import image3 from "@/assets/images/icons/icon_xiazai_guojia@3x.png"
import iconModular from "@/assets/images/bg/mkfq.png"
import iconTech from "@/assets/images/bg/jsqd.png"
import iconTransparent from "@/assets/images/bg/jytm.png"
import iconSupport from "@/assets/images/bg/jszc.png"
import BlogPagination from "@/components/pagination/BlogPagination";
import BlogSidebar from "@/components/blog/BlogSidebar";
import DownloadConfirmModal from '@/components/DownloadConfirmModal/DownloadConfirmModal.vue';
export default {
    name: 'BlogSingleColumn',
    components: { BlogSidebar, BlogPagination, Pagination, BlogCard, Breadcrumb, Layout, DownloadConfirmModal },
    mixins: [SalScrollAnimationMixin, BlogMixin],
    data() {
        return {
            showDownloadModal: false, // 控制弹窗显示/隐藏
            activeFeature: 0, // 当前选中的功能模块
            securityIndex: 0, // H5 资金安全卡片轮播索引
            securityTimer: null, // H5 资金安全卡片轮播定时器
            features: [
                {
                    icon: iconModular,
                    title: this.$t('appd.f1t'),
                    desc: this.$t('appd.f1d'),
                    phoneImage: 'app_img1.png',
                    h5Image: 'app_img1_1.png'
                },
                {
                    icon: iconTech,
                    title: this.$t('appd.f2t'),
                    desc: this.$t('appd.f2d'),
                    phoneImage: 'app_img4.png',
                    h5Image: 'app_img4_1.png'
                },
                {
                    icon: iconTransparent,
                    title: this.$t('appd.f3t'),
                    desc: this.$t('appd.f3d'),
                    phoneImage: 'app_img2.png',
                    h5Image: 'app_img2_1.png'
                },
                {
                    icon: iconSupport,
                    title: this.$t('appd.f4t'),
                    desc: this.$t('appd.f4d'),
                    phoneImage: 'app_img3.png',
                    h5Image: 'app_img3_1.png'
                }
            ],
            departments: [
                {
                    name: this.$t('appDownload.establish'),
                    desc: '2023',
                    icon: image1,
                    isActive: true
                },
                {
                    name: this.$t('appDownload.user'),
                    desc: '12000+',
                    icon: image2,
                    isActive: true
                },
                {
                    name: this.$t('appDownload.country'),
                    desc: this.$t('appDownload.globalUsers'),
                    description: this.$t('appDownload.restriction'),
                    icon: image3,
                    isActive: true
                },
            ],
            pageStart: '',
            countOfPage: ''

        }
    },
    // H5/平板下资金安全卡片自动轮播（同投资理念轮播模式）
    mounted() {
        if (window.innerWidth <= 991) {
            this.securityTimer = setInterval(this.nextSecurity, 3000);
        }
    },
    beforeDestroy() {
        if (this.securityTimer) clearInterval(this.securityTimer);
    },
    methods: {
        // 点击切换面板：循环切换功能模块（面板内容 + 左侧手机图联动）
        nextFeature() {
            this.activeFeature = (this.activeFeature + 1) % this.features.length;
        },
        // 资金安全卡片轮播：3 张循环
        nextSecurity() {
            this.securityIndex = (this.securityIndex + 1) % 3;
        },
        paginatedData(filteredRows, pageStart, countOfPage) {
            this.filteredRows = filteredRows;
            this.pageStart = pageStart;
            this.countOfPage = countOfPage;
        }
    }
}
</script>
<style scoped lang="scss">
.android-btn {
    background-color: #FFD200;
    color: #212121;
    border: 1px solid #FFD200;
    height: 60px;
    width: 170px;

    &:hover {
        background-color: #FFD200;
        border-color: #FFD200;
    }
}

.ios-btn {
    background-color: #181A20;
    color: #F5F5F5;
    border: 1px solid #313B46;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 24px;
    font-size: 16px;
    font-weight: 500;
    border-radius: 6px;
    width: 100px
}

.app-promo-section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 60px 0px 60px 0px;
    color: #fff;
    font-family: 'Microsoft Yahei', sans-serif;
    max-width: 1440px;
    flex-wrap: wrap;
    margin: 0 auto;

    .visual-area {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        // width: 45%;

        .phone-container {
            z-index: 2;
            position: relative;

            .phone-screen {
                width: 680px;
                height: auto;
                border-radius: 30px;
                // box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
            }
        }

        .decorative-elements {
            position: absolute;
            z-index: 1;
            display: flex;
            align-items: center;
            justify-content: center;

            .coin {
                position: absolute;
                width: 80px;
                height: auto;
                opacity: 0.8;
                transition: transform 0.3s ease;

                &:hover {
                    transform: scale(1.05);
                }
            }

            .dollar-coin {
                bottom: 40px;
                left: -40px;
            }

            .gold-coin {
                top: 60px;
                right: -30px;
                width: 60px;
            }
        }

        .font-size-tag {
            position: absolute;
            left: -60px;
            top: 50%;
            transform: translateY(-50%);
            background-color: #e91e63;
            color: #fff;
            font-size: 12px;
            padding: 4px 8px;
            border-radius: 4px;
        }
    }

    .text-action-area {
        // width: 45%;
        // padding-left: 6.25rem;
        padding: 30px;
        // max-width: 80vw;

        .main-title {
            font-size: 22px;
            line-height: 1.4;
            margin-bottom: 20px;
            display: flex;

            .highlight {
                color: #ffc107;
            }
        }

        .desc {
            font-size: 14px;
            color: #ccc;
            line-height: 1.6;
            margin-bottom: 10px;
            max-width: 400px;
        }

        .download-buttons {
            display: flex;
            gap: 20px;
            // width: 450px;
            padding-left: 15px;
            padding-right: 15px;
            max-width: 90vw;
            height: 80px;
            border: 1px solid #ffd200;
            border-radius: 8px;
            margin-top: 30px;

            justify-content: space-around;
            align-items: center;

            .download-buttons_list {
                padding: 10px;
                // padding-left: 30px;
                // padding-right: 30px;
                color: #ffd200;
                display: flex;
                flex-direction: column;
                align-items: center;

                font-size: 16px;
            }

            .download-buttons_list_title {
                color: #F5F5F5;
                opacity: 0.7;
                font-size: 12px;
                // white-space: nowrap;
                text-align: center;

            }

            .line {
                height: 40px;
                min-width: 1px;
                background-color: #838E9F;
            }

            // .download-buttons_list:nth-child(2) {
            //     border-left: 1px solid #838E9F;
            //     border-right: 1px solid #838E9F;
            // }


        }
    }
}

.container {
    /* background-color: #1f2937; */
    padding: 1.25rem;
    color: #fff;
}

.routeB {
    width: 12.375rem;
    height: 3.75rem;
    background: #FFD200;
    border-radius: 8px;
    color: #181A20;
    font-weight: 550;
}

.title::after {
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 4px;
    background-color: #f1c40f;
}

.card-group {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 1.25rem;
}

.card-item {
    width: calc(30% - .625rem);
    background-color: #27313D;
    border-radius: .5rem;
    box-sizing: border-box;
    margin-top: 20rem;
    padding-bottom: 3rem;
}

.card-img {
    margin-bottom: .9375rem;
    overflow: hidden;
    border-radius: .25rem;
    position: relative;
    height: 24.25rem;
    width: 100%;
    display: flex;
    justify-content: center;

}

.card-home {
    margin-top: 10px;
    padding: 1.875rem;
    height: 250px;
    display: flex;
    flex-direction: column;
    justify-content: left;
}

.card-img img {
    width: 57.5rem;
    height: auto;
    display: block;
}

.card-title {
    font-size: 2.125rem;
    margin-bottom: 10.625rem;
    font-weight: 600;
}

.card-desc {
    font-size: 18px;
    color: #9ca3af;
    margin-bottom: 1.25rem;
    line-height: 1.5;
}

.card-link {
    font-size: 14px;
    color: #FFD200;
    text-decoration: none;
    display: inline-block;
}

@media (max-width: 768px) {
    .card-item {
        width: 100%;
    }

    // .download-buttons{
    //     width: 90vw;
    // }
    .download-buttons_list {
        font-size: 10px !important;
    }

    .download-buttons_list_title {
        font-size: 8px !important;
    }
}

.about-us {

    color: #ecf0f1;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20rem;
}

.about-us h2 {
    text-align: center;
    margin-bottom: 20px;
    position: relative;

}

.about-us h2::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 4px;
    // background-color: #f1c40f;
}

.accordion-item {
    border-bottom: 1px solid #34495e;
    width: calc(57%);
    min-width: 35rem;
    background-color: #171524;

}

.accordion-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0;
    padding-left: 1rem;
    padding-right: 1.875rem;
    height: 8rem;
    cursor: pointer;
}

.accordion-header .icon {
    transition: transform 0.3s ease;
}

.accordion-header .icon.active {
    transform: rotate(45deg);
}

.accordion-content {
    padding-bottom: 15px;
    padding-left: 1.875rem;
}

.partner-section {
    background-color: #171524;
    /* 匹配界面深蓝色 #1A2A47 */
    padding: 40px 20px;
    text-align: center;
}

.section-title {
    color: #FFFFFF;
    font-size: 24px;
    margin-bottom: 10px;
}

.section-subtitle {
    color: #C0C5CD;
    font-size: 14px;
    margin-bottom: 30px;
}

.partner-list {
    //   display: flex;
    //   flex-wrap: wrap;
    //   justify-content: center;
    gap: 20px;
    margin-bottom: 40px;
    /* 与留白区域的间距 */
    margin: 0 auto;

}

.partner-item {
    width: calc(15%);
    /* 两列布局，适配H5 */
    min-width: 15rem;
    padding: 15px;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
}

.partner-logo {
    max-width: 100%;
    height: auto;
}

.space-block {
    height: 60px;
    /* 留白高度，可自定义 */
    background-color: #171524;
}

.plan-section {
    display: flex;
    background-color: #0F172A;
    /* 深色背景匹配设计 */
    color: #E2E8F0;
    // padding: 30px;
    height: 50rem;
    font-family: "Microsoft Yahei", sans-serif;
    max-width: 1500px;
}

/* 左侧信息图表区样式 */
.plan-chart {
    flex: 2;
    position: relative;

}

.chart-center {
    position: relative;
    text-align: center;
    margin-bottom: 40px;
}

.center-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 15px;
    color: #FFFFFF;
}

.center-img {
    width: 180px;
    height: 180px;
    border-radius: 50%;
    object-fit: cover;
    border: 2px solid #171524;
}

.chart-points {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
}

.point-item {
    width: 45%;
    margin-bottom: 20px;
}

.point-label {
    display: inline-block;
    background-color: #171524;
    color: #FFFFFF;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    margin-bottom: 8px;
}

.point-desc {
    font-size: 14px;
    line-height: 1.5;
    opacity: 0.9;
}

/* 右侧文本区样式 */
.plan-text {
    flex: 1;
    background-color: #27313D;
    /* 右侧深蓝色区块 */
    width: 73rem;
    padding: 30px;
    // border-radius: 8px;
}

.text-title {
    font-size: 20px;
    color: #FFFFFF;
    margin-bottom: 15px;
    border-left: 4px solid #F59E0B;
    padding-left: 10px;
}

.text-list {
    list-style: none;
    margin-bottom: 20px;
    margin-top: 10px;
}

.list-item {
    margin-bottom: 12.5rem;
}

.list-label {
    font-weight: 550;

}

.sublist {
    // margin-left: 20px;
    margin-top: 5px;
}

.text-btn {

    color: #F3B701;
    border: none;
    padding: 8px 16px;
    padding-left: 0;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: background-color 0.3s;
    text-align: left;

}

/* 响应式适配H5 */
@media (max-width: 768px) {
    .plan-section {
        flex-direction: column;
    }

    .plan-chart,
    .plan-text {
        width: 100%;
        margin-bottom: 20px;
    }

    .point-item {
        width: 100%;
    }
}

.department-section {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    width: 100%;
    padding: 40px 20px;
}

.department-card {
    width: calc(23% - 20px);
    /* 四列布局，适配间距 */
    border: 2px solid #333B47;
    padding: 20px;
    text-align: center;
    box-sizing: border-box;
    height: 200px;
    margin-bottom: 20px;
    text-align: left;
    text-align: top;
    display: flex;
    align-items: center;
    flex-direction: column;
    border-radius: 8px;
}




.card-icon {
    width: 50px;
    height: 50px;
    margin-bottom: 0.875rem;
    display: flex;
    justify-content: center;
    align-items: center;
    // background-color: rgba(255, 255, 255, 0.1);
    border-radius: 8px;
}

.card-icon img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.card-title {
    color: #FFFFFF;
    font-size: 28px;
    margin-bottom: 30px;
    height: 30px;
}

.card-line {
    height: 8px;
    background-color: #9ca3af;
    opacity: 0.2;
    margin: 15px 0;
}

.card-desc {
    color: #CBD5E1;
    font-size: 14px;
    line-height: 1.5;
}

/* 响应式适配H5 */
@media (max-width: 768px) {
    .department-card {
        width: calc(50% - 20px);
        /* 移动端两列布局 */
    }
}

@media (max-width: 480px) {
    .department-card {
        width: 100%;
        /* 移动端单列布局 */
    }
}

.bg_app {
    background-image: url("~@/assets/images/bg/appbg.png");
    background-size: cover;
    // background-position: center;
    // background-repeat: no-repeat;

}

/* ========== App Download Wrapper ========== */
.app-download-wrapper {

    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

/* ========== App Banner 新样式 ========== */
.app-banner {
    padding: 180px 0;
}

.app-banner-content {
    text-align: left;
}

.app-brand {
    font-size: 64px;
    font-weight: 700;
    color: #FFD200;
    margin-bottom: 10px;
    letter-spacing: 1px;
}

.app-title {
    font-size: 22px;
    font-weight: 600;
    color: #FFFFFF;
    margin-bottom: 20px;
    line-height: 1.3;
}

.app-desc {
    font-size: 22px;
    color: rgba(255, 255, 255, 0.6);
    margin-bottom: 30px;
    line-height: 1.6;
}

.app-buttons {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 30px;
}

.app-buttons .android-btn {
    background-color: #FFD200;
    color: #FFFFFF;
    border: none;
    padding: 14px 28px;
    font-size: 20px;
    font-weight: 600;
    border-radius: 8px;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: all 0.3s ease;
}

.app-buttons .android-btn:hover {
    transform: scale(1.05);
    color: #FFFFFF;
    box-shadow: 0 0 25px rgba(255, 250, 220, 0.4);
}

.app-buttons .h5-btn:hover {
    transform: scale(1.05);
    color: #FFFFFF;
    box-shadow: 0 0 25px rgba(255, 250, 220, 0.4);
}

.app-buttons .android-btn img,
.app-buttons .h5-btn .h5-icon {
    width: 20px;
    height: 20px;
}

.app-buttons .h5-btn {
    background-color: rgba(26, 31, 46, 0.8);
    color: #FFFFFF;
    border: 1px solid rgba(255, 255, 255, 0.3);
    padding: 14px 28px;
    font-size: 20px;
    font-weight: 600;
    border-radius: 8px;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: all 0.3s ease;
}

.app-buttons .h5-btn:hover {
    transform: scale(1.05);
    color: #FFFFFF;
}

.app-users {
    display: flex;
    align-items: center;
    gap: 12px;
}

.user-avatars {
    display: flex;
    align-items: center;
    img{
        width: 200px;
    }
}

.avatar-stack {
    width: 150px;
    height: auto;
    border-radius: 50%;
    margin-top: 20px;
}

.user-stats {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.stats-number {
    font-size: 16px;
    font-weight: 600;
    color: #FFD200;
}

.stats-text {
    font-size: 16px;
    color: rgba(255, 255, 255, 0.5);
}

.app-phone-showcase {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}

.phone-placeholder {
    width: 280px;
    height: 560px;
    background-color: rgba(255, 255, 255, 0.05);
    border: 2px dashed rgba(255, 255, 255, 0.2);
    border-radius: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* ========== App Features Section ========== */
.app-features-section {
    padding: 200px 0;
}

.feature-phone-showcase {
    display: flex;
    justify-content: center;
    align-items: center;
    img{
        width: 500px;
        margin-right: 100px;
    }
}

.feature-phone-img {
    width: 300px;
    height: auto;
    border-radius: 20px;
}

/* H5 专用手机图：桌面端隐藏 */
.feature-phone-img-h5 {
    display: none;
}


.feature-content {
    padding-left: 40px;
}

.feature-main-title {
    font-size: 36px;
    font-weight: 700;
    color: #FFFFFF;
    margin-bottom: 16px;
}

.feature-desc {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.6);
    line-height: 1.6;
    margin-bottom: 30px;
}

/* 功能模块切换面板：点击整块切换内容 */
.feature-switch-panel {
    background: #1A1F2E;
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 12px;
    padding: 20px;
    cursor: pointer;
    transition: all 0.3s ease;
    margin-bottom: 30px;
    user-select: none;
}

.feature-switch-panel:hover {
    border-color: rgba(255, 255, 255, 0.35);
    box-shadow: 0 0 20px rgba(255, 255, 255, 0.15);
}

.feature-icon-box {
    width: 40px;
    height: 40px;
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgba(255, 255, 255, 0.18);
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.04);
}

.feature-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 10px;
}

.feature-icon-img {
    width: 22px;
    height: 22px;
    object-fit: contain;
}

.feature-title {
    font-size: 16px;
    font-weight: 600;
    color: #FFFFFF;
    margin-bottom: 0;
    transition: color 0.3s ease;
}

.feature-text {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.55);
    line-height: 1.7;
    transition: color 0.3s ease;
    margin-left: 0;
    margin-bottom: 12px;
}

.feature-chevron {
    display: block;
    margin: 0 auto;
}

/* 手机图切换过渡 */
.phone-fade-enter-active,
.phone-fade-leave-active {
    transition: opacity 0.3s ease;
}

.phone-fade-enter-from,
.phone-fade-leave-to {
    opacity: 0;
}

.feature-stats {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 22px 40px;
}

.stat-item {
    display: flex;
    align-items: center;
    gap: 8px;
}

.stat-number {
    font-size: 24px;
    font-weight: 700;
    color: #FFD200;
}

.stat-label {
    font-size: 15px;
    color: rgba(255, 255, 255, 0.5);
}

/* 响应式适配：H5/平板 保持左手机右内容的紧凑横排（同设计稿） */
@media (max-width: 991px) {
    .app-features-section {
        padding: 60px 0;
    }

    .app-features-section .row {
        align-items: center;
    }

    .app-features-section .row > [class*="col-"] {
        margin-top: 0;
    }

    .app-features-section .row > [class*="col-"]:first-child {
        flex: 0 0 45%;
        max-width: 45%;
    }

    .app-features-section .row > [class*="col-"]:last-child {
        flex: 0 0 55%;
        max-width: 55%;
    }

    /* .feature-phone-showcase img 嵌套规则优先级更高，这里需提升优先级覆盖 */
    .app-features-section .feature-phone-img {
        display: none;
    }

    /* H5 显示专用手机图（_1 版本）并加阴影 */
    .app-features-section .feature-phone-img-h5 {
        display: block;
        width: 100%;
        max-width: 170px;
        margin-right: 0;
        border-radius: 20px;
        box-shadow: 0 18px 40px rgba(0, 0, 0, 0.55);
    }

    .feature-content {
        padding-left: 12px;
        margin-top: 0;
    }

    .feature-main-title {
        font-size: 20px;
        margin-bottom: 8px;
    }

    .feature-desc {
        font-size: 11px;
        line-height: 1.6;
        margin-bottom: 14px;
    }

    .feature-switch-panel {
        padding: 12px 14px;
        border-radius: 10px;
        margin-bottom: 16px;
    }

    .feature-switch-panel .feature-header {
        gap: 8px;
        margin-bottom: 8px;
    }

    .feature-icon-box {
        width: 30px;
        height: 30px;
        border-radius: 8px;
    }

    .feature-switch-panel .feature-icon-img {
        width: 16px;
        height: 16px;
    }

    .feature-switch-panel .feature-title {
        font-size: 14px;
    }

    .feature-switch-panel .feature-text {
        font-size: 11px;
        line-height: 1.6;
        margin-bottom: 8px;
    }

    .feature-chevron {
        width: 14px;
        height: 14px;
    }

    .feature-stats {
        gap: 14px 20px;
    }

    .stat-number {
        font-size: 18px;
    }

    .stat-label {
        font-size: 10px;
        white-space: nowrap;
    }
}

.phone-placeholder::after {
    content: '手机图片';
    color: rgba(255, 255, 255, 0.3);
    font-size: 14px;
}

/* App Banner 响应式（H5/平板同步） */
@media (max-width: 991px) {
    .app-banner {
        padding: 40px 0;
    }

    /* H5 保持左右布局（文字左、手机右），按截图紧凑比例排列 */
    .app-banner .row {
        /* 覆盖全局 .row-reverce-sm 的小屏 column-reverse */
        flex-direction: row;
        align-items: center;
    }

    .app-banner .row > [class*="col-"] {
        margin-top: 0;
    }

    /* 文字列 55% / 手机列 45%，缓解 50/50 时的拥挤 */
    .app-banner .row > [class*="col-"]:first-child {
        flex: 0 0 55%;
        max-width: 55%;
    }

    .app-banner .row > [class*="col-"]:last-child {
        flex: 0 0 45%;
        max-width: 45%;
    }

    .app-brand {
        font-size: 24px;
        margin-bottom: 6px;
    }

    .app-title {
        font-size: 14px;
        margin-bottom: 10px;
    }

    .app-desc {
        font-size: 11px;
        margin-bottom: 14px;
    }

    .app-buttons {
        gap: 8px;
        margin-bottom: 14px;
    }

    .app-buttons .android-btn,
    .app-buttons .h5-btn {
        /* 覆盖基础 .android-btn 的固定 width:170px/height:60px，两个按钮统一为同一紧凑盒子 */
        width: auto;
        height: 32px;
        padding: 0 14px;
        font-size: 12px;
        border-radius: 16px;
        white-space: nowrap;
        box-sizing: border-box;
        line-height: 1;
        flex: 0 0 auto;
    }

    .app-buttons .android-btn img {
        width: 14px !important;   /* 覆盖模板行内 width:25px */
        height: 14px;
        object-fit: contain;
    }

    .app-buttons .h5-btn .h5-icon {
        width: 14px;
        height: 14px;
    }

    .app-users {
        gap: 8px;
    }

    .user-avatars img {
        width: 65px;
    }

    .avatar-stack {
        margin-top: 0;
    }

    .stats-number {
        font-size: 11px;
    }

    .stats-text {
        font-size: 9px;
        white-space: nowrap;
    }

    .app-phone-img {
        width: 100%;
        max-width: 140px;
        height: auto;
    }

    .phone-placeholder {
        width: 200px;
        height: 400px;
        margin-top: 40px;
    }
}

/* ========== 资金安全保障 Section ========== */
.security-section {
    padding: 200px 0;
    background-color: transparent;
}

.security-title {
    text-align: center;
    font-size: 36px;
    font-weight: 700;
    color: #FFFFFF;
    margin-bottom: 16px;
}

.security-subtitle {
    text-align: center;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.6);
    margin-bottom: 50px;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
}

.security-carousel {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
}

/* H5 轮播透传：桌面端卡片仍作为网格项直接参与布局 */
.security-carousel .security-viewport,
.security-carousel .security-track {
    display: contents;
}

.security-card {
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 16px;
    padding: 30px;
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    min-height: 380px;
}

.security-card .security-tags {
    margin-top: auto;
}

.security-card:hover {
    border-color: rgba(255, 255, 255, 0.4);
    transform: translateY(-5px);
    box-shadow: 0 0 30px rgba(255, 250, 220, 0.3);
}

.security-card-1 {
    // background-image: url("~@/assets/images/bg/组 66.png");
    background-size: cover;
    background-position: center;
}

.security-card-2 {
    // background-image: url("~@/assets/images/bg/组 80.png");
    background-size: cover;
    background-position: center;
}

.security-card-3 {
    // background-image: url("~@/assets/images/bg/组 94.png");
    background-size: cover;
    background-position: center;
}

.security-icon-img {
    width: 48px;
    height: 48px;
    margin-bottom: 16px;
}

.security-icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    font-size: 24px;
}

.security-icon.blue {
    background: rgba(59, 130, 246, 0.2);
    color: #3B82F6;
}

.security-icon.green {
    background: rgba(34, 197, 94, 0.2);
    color: #22C55E;
}

.security-icon.yellow {
    background: rgba(234, 179, 8, 0.2);
    color: #EAB308;
}

.security-card-title {
    font-size: 20px;
    font-weight: 600;
    color: #FFFFFF;
    margin-bottom: 20px;
}

.security-list {
    list-style: none;
    padding: 0;
    margin: 0 0 20px 0;
}

.security-list li {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.6);
    margin-bottom: 10px;
    padding-left: 30px;
    position: relative;
}

.security-list li::before {
    content: '';
    position: absolute;
    left: 0;
    top: 2px;
    width: 16px;
    height: 16px;
    background-image: url("~@/assets/images/bg/图标 17.png");
    background-size: contain;
    background-repeat: no-repeat;
}

.security-tags {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
}

.security-tags span {
    padding: 8px 18px;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 500;
}

.tag-outline {
    border: 1px solid #22C55E;
    color: #22C55E;
    background: transparent;
}

.tag-green {
    background: rgba(34, 197, 94, 0.15);
    color: #22C55E;
    border: 1px solid rgba(34, 197, 94, 0.3);
}

.tag-yellow {
    background: rgba(234, 179, 8, 0.15);
    color: #EAB308;
    border: 1px solid rgba(234, 179, 8, 0.3);
}

.tag-blue {
    background: rgba(59, 130, 246, 0.15);
    color: #3B82F6;
    border: 1px solid rgba(59, 130, 246, 0.3);
}

/* ========== CTA Section ========== */
.cta-section {
    padding: 300px 0;
    background-image: url("~@/assets/images/bg/组 6610.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    text-align: center;
}

.cta-content {
    max-width: 600px;
    margin: 0 auto;
}

.cta-brand {
    font-size: 62px;
    font-weight: 700;
    color: #FFD200;
    margin-bottom: 10px;
    letter-spacing: 1px;
    transition: none;
}

.cta-title {
    font-size: 56px;
    font-weight: 600;
    color: #FFFFFF;
    margin-bottom: 16px;
    transition: none;
}

.cta-desc {
    font-size: 24px;
    color: rgba(255, 255, 255, 0.6);
    margin-bottom: 30px;
    transition: none;
}

.cta-buttons {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
}

.cta-android-btn {
    background-color: #FFD200;
    color: #FFFFFF;
    border: none;
    padding: 14px 20px;
    font-size: 16px;
    font-weight: 600;
    border-radius: 8px;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: all 0.3s ease;
}

.cta-android-btn:hover {
    transform: scale(1.05);
    color: #FFFFFF;
    box-shadow: 0 0 25px rgba(255, 250, 220, 0.4);
}

.cta-h5-btn:hover {
    transform: scale(1.05);
    color: #FFFFFF;
    box-shadow: 0 0 25px rgba(255, 250, 220, 0.4);
}

.cta-android-btn img {
    width: 20px;
    height: 20px;
}

.cta-h5-btn {
    background-color: rgba(26, 31, 46, 0.8);
    color: #FFFFFF;
    border: 1px solid rgba(255, 255, 255, 0.3);
    padding: 14px 28px;
    font-size: 16px;
    font-weight: 600;
    border-radius: 8px;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: all 0.3s ease;
}

.cta-h5-btn .h5-icon {
    width: 20px;
    height: 20px;
}

.cta-h5-btn:hover {
    box-shadow: 0 0 20px rgba(255, 250, 220, 0.4);
}

/* CTA Section 响应式（H5/平板同步） */
@media (max-width: 991px) {
    .cta-section {
        padding: 60px 0;
    }

    .cta-brand {
        font-size: 20px;
        margin-bottom: 6px;
    }

    .cta-title {
        font-size: 18px;
        margin-bottom: 8px;
    }

    .cta-desc {
        font-size: 11px;
        margin-bottom: 20px;
    }

    /* H5 按设计稿：两个按钮并排、紧凑胶囊 */
    .cta-buttons {
        flex-direction: row;
        gap: 10px;
    }

    .cta-android-btn,
    .cta-h5-btn {
        padding: 0 16px;
        height: 32px;
        font-size: 12px;
        border-radius: 16px;
        box-sizing: border-box;
    }

    .cta-android-btn img {
        width: 14px !important;   /* 覆盖模板行内 width:25px */
        height: 14px;
        object-fit: contain;
    }

    .cta-h5-btn .h5-icon {
        width: 14px;
        height: 14px;
    }
}

/* 资金安全保障响应式 */
@media (max-width: 992px) {
    .security-carousel {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 991px) {
    .security-section {
        padding: 60px 0;
    }

    .security-title {
        font-size: 28px;
    }

    .security-carousel {
        display: block;
    }

    /* H5 轮播：视口裁剪 + 轨道横向排列 */
    .security-carousel .security-viewport {
        display: block;
        overflow: hidden;
        width: 100%;
    }

    .security-carousel .security-track {
        display: flex;
        flex-direction: row;
        align-items: stretch;
        justify-content: flex-start;
        gap: 0;
        transition: transform 0.4s ease;
    }

    .security-carousel .security-card {
        flex: 0 0 100%;
        max-width: 100%;
        box-sizing: border-box;
    }
}
</style>